import DropDownWithSearch from "components/DropDownWithSearch/DropDownWithSearch";
import React from "react";

const CustomDropdownWithSearch = ({
  label,
  optionsList,
  selectedOption,
  setValue,
  currentState,
  name,
}) => {
  return (
    <DropDownWithSearch
      label={label}
      optionsList={optionsList}
      selectedOption={selectedOption || ""}
      setValue={setValue}
      currentState={currentState}
      name={name}
    />
  );
};

export default CustomDropdownWithSearch;
